// src/components/media360/domain/playerUrl.js
// Generación de URL “perfecta” para el Revi-VR-Player (param-driven, minimal UI).

const DEFAULT_PLAYER_BASE = "https://revi-vr-prod.web.app";

/**
 * @param {Object} experience
 * @param {"video"|"image"} experience.mediaKind
 * @param {Object} experience.media
 * @param {string} experience.media.publicUrl
 * @param {"mono"|"3d-tb"|"3d-sbs"} experience.mode
 * @param {boolean} experience.loop
 * @param {Object|null} experience.audio
 * @param {string=} experience.audio.publicUrl
 * @param {Object=} opts
 * @param {string=} opts.playerBase
 * @param {boolean=} opts.forceAudioLoop   // si true, audioLoop=on cuando haya audio (recomendado)
 */
export function buildPlayerUrlFromExperience(experience, opts = {}) {
  const playerBase = opts.playerBase || DEFAULT_PLAYER_BASE;

  const u = new URL(playerBase);
  const src = experience?.media?.publicUrl || "";
  const mode = experience?.mode || "mono";
  const type = experience?.mediaKind || "video";

  u.searchParams.set("type", type);
  u.searchParams.set("src", src);
  u.searchParams.set("mode", mode);

  // Loop: solo añadimos si está activado
  if (experience?.loop) {
    u.searchParams.set("loop", "on");
  }

  // Audio asociado (para imagen normalmente, pero soporta ambos)
  const audioUrl = experience?.audio?.publicUrl;
  if (audioUrl) {
    u.searchParams.set("audioSrc", audioUrl);

    // Por simplicidad, el audio sigue el loop principal
    if (opts.forceAudioLoop || experience?.loop) {
      u.searchParams.set("audioLoop", "on");
    }
  }

  return u.toString();
}
